import { oc } from '@orpc/contract';
import { listKpisInputSchema, listKpisOutputSchema } from '../schemas/kpis.schemas.js';
export const listKpisContract = oc
    .route({
    method: 'GET',
    path: '/kpis',
    tags: ['KPIs'],
    summary: 'List the KPIs of the pillars the caller may see (filters: pillar, search, includeInactive)',
})
    .input(listKpisInputSchema)
    .output(listKpisOutputSchema);
//# sourceMappingURL=list-kpis.contract.js.map